// wrap a concatenated module body as a lazy, memoized accessor; mod is
// set before the body runs so re-entrant calls (require cycles) observe
// the partial exports like Node.js
__webpack_require__.cw = (body) => {
	var mod;
	return () => {
		if (body) {
			var fn = body;
			body = 0;
			mod = { exports: {} };
			try {
				fn.call(mod.exports, mod, mod.exports);
			} catch (e) {
				mod.error = e;
				throw e;
			}
		}
		if (mod.error !== undefined) throw mod.error;
		return mod.exports;
	};
};